import React from "react";
import {NavLink} from "react-router-dom";
import PageActions from "../../../base/PageActions";
import ContentBox from "../../../../components/content-box/ContentBox";
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import _image_service from "../../../../services/ImageService";
import '../../../styles/Common.scss';
import './WorldPages.scss';

interface WorldPageProps {
}

const WorldPage = (props: WorldPageProps) => {

    const page: PageActions = new PageActions({
        title: `The World of Casarok - Chase the Fox`,
        description: `Learn about Chase's home, the Earth-like world of Casarok.`,
        keywords: ["casarok", "chase's world", "worldbuilding", "anthropomorphic world", "fantasy world"],
        imgSrc: `chase/world/casarok_view.png`,
        url: `world`
    });

    return page.generateMetaContent(
        <>
            <ContentBox header="Welcome to the World of Casarok">
                <Breadcrumbs path={page.getUrl()}/>
                <img className="block width-50-percent"
                     src={_image_service.getCdnImageSrc(`chase/world/casarok_intro.png`)}
                     alt="The Mysterious World Casarok"/>
                <div className="world-content world-page-static">
                    <p>
                        Casarok is the homeworld of Chase and his friends. This world exists far from the planet
                        Earth, and it is currently unknown whether or not this planet is even located in the same
                        universe. It shares many similarities with Earth such as its composition, development, and
                        diversity of life; however, magic runs deep within the planet brought about by its
                        pantheon of gods and goddesses.
                    </p>
                    <p>
                        See more about the world by checking the various information pages:
                    </p>
                    <ol className="spaced">
                        <li>
                            <NavLink className="world-link block" to="bestiary">Bestiary</NavLink>
                            The list of unique creatures found in Casarok.
                        </li>
                        <li>
                            <NavLink className="world-link block" to="botanary">Botanary</NavLink>
                            A specification of the various plant life native to this world.
                        </li>
                        <li>
                            <NavLink className="world-link block" to="magic">Magic</NavLink>
                            A guide to the workings of magic.
                        </li>
                        <li>
                            <NavLink className="world-link block" to="geography">Geography</NavLink>
                            The map of the world and its natural landmarks, past and present.
                        </li>
                        <li>
                            <NavLink className="world-link block" to="history">History</NavLink>
                            A brief description of the eras and ages of Casarok.
                        </li>
                        <li>
                            <NavLink className="world-link block" to="languages">Languages</NavLink>
                            Although Common is the most spoken language in the modern world, a variety of different
                            tongues have been spoken through the world's history.
                        </li>
                        <li>
                            <NavLink className="world-link block" to="religion">Religion</NavLink>
                            Religion in Casarok has mostly been dictated by the gods and goddesses. In the past,
                            there presence fostered various mythologies were formed. In the present, different faiths
                            emerged from the pantheon's teachings.
                        </li>
                    </ol>
                </div>
            </ContentBox>
        </>
    );
}

export default WorldPage;